import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createUser, getDrivers } from "../../actions/userActions";
import defaultPic from "../../assets/img/dummy.jpeg";
import AWS from "aws-sdk";
import axios from "axios";
import {
  BUCKET_ACCESS_KEY_ID,
  BUCKET_BASE_URL,
  BUCKET_ENDPOINT,
  BUCKET_NAME,
  BUCKET_REGION,
  BUCKET_SECRET_KEY,
  SERVERADDRESS,
} from "../../../src/constants";

const S3_BUCKET = BUCKET_NAME;
// const REGION ='YOUR_DESIRED_REGION_HERE';

AWS.config.update({
  accessKeyId: BUCKET_ACCESS_KEY_ID,
  secretAccessKey: BUCKET_SECRET_KEY,
});
const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: BUCKET_REGION,
  endpoint: BUCKET_ENDPOINT,
  // region: REGION,
});

const AdminCreateDriverModal = ({ showAddModal, openAddModal }) => {
  const driver = useSelector((state) => state.driver);
  const users = useSelector((state) => state.users);
  const city = useSelector((state) => state.city);
  const auth = useSelector((state) => state.auth);
  const [progress, setProgress] = useState(0);
  const [awsURL, setAwsURL] = useState(null);
  const [selectedImage, setSelectedImage] = useState(defaultPic);
  const [profileData, setProfileData] = useState({});

  // const { loading } = store;
  //   console.log(auth, "auth");

  const navigate = useNavigate();
  const [values, setValues] = useState({
    // userId: "",
    firstName: "",
    lastName: "",
    gender: "",
    phone: "",
    email: "",
    password: "",
    address: "",
    profilePic: "",

    // role: "",
    // createDate: "",
  });
  console.log(values, "values");

  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };
  const dispatch = useDispatch();

  const driverData = {
    firstName: values.firstName,
    lastName: values.lastName,
    email: values.email,
    password: values.password,
    gender: values.gender ? values.gender : "male",
    phone: values.phone,
    role: "driver",
    address: values.address,
    city: values.city,
    profilePic: values.profilePic,
    // createDate: values.createDate,
  };

  //   console.log(driverData, "driverData");
  const cb = () => {
    // console.log("cbbbbb", cb);
    dispatch(getDrivers());
    openAddModal();
    setValues({
      //   name: "",
      profilePic: "",
      firstName: "",
      lastName: "",
      gender: "",
      phone: "",
      email: "",
      password: "",
      address: "",
      city: "",
    });
  };

  const handleChangePic = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Display the selected image immediately
    const tempUrl = URL.createObjectURL(file);
    setSelectedImage(tempUrl);

    console.log("Uploading file...");
    // console.log("cccccccccccccccc");

    const today = new Date();
    const date = today.getTime();
    const params = {
      Bucket: S3_BUCKET,
      //   Key:
      //     "data/" +
      //     "SuperAdminData" +
      //     "/ProfilePic/" +
      //     date +
      //     "/" +
      //     event.target.files[0].name,
      //   Body: event.target.files[0],
      Key: `data/SuperAdminData/ProfilePic/${date}/${file.name}`,
      Body: file,
      ACL: "public-read",
    };
    var upload = myBucket
      .upload(params)
      .on("httpUploadProgress", (evt) => {
        setProgress(Math.round((evt.loaded / evt.total) * 100));
      })
      .promise();
    let url;
    await upload.then(function (data, err) {
      try {
        url = BUCKET_BASE_URL + data.Key;
        setAwsURL(url);
        console.log(url, "url");
      } catch (error) {
        // console.log(error, err, "ee");
      }
      console.log(upload, "upload");
    });

    const { data } = await axios.post(
      `${SERVERADDRESS}/v1/fileupload/profilePicUpload`,
      {
        // url: url,
        // file: event.target.files[0].name,
        // type: event.target.files[0].type,
        url: url,
        file: file.name,
        type: file.type,
        // userId: auth.user.id,
        // companyId: auth.user.companyId.id,
      }
    );
    // setSelectedImage(url);
    setValues({
      ...values,
      ["profilePic"]: data.id,
    });
    // dispatch(createUser({ userId: auth.user.id, profilePic: data.id }));
    console.log(data, "data");
  };
  //   console.log(handleChangePic, "handleChangePic");

  const handlePhone = (fieldName) => (event) => {
    const numericValue = event.target.value.replace(/\D/g, "");
    let formattedValue = "";
    if (numericValue.length > 0) {
      formattedValue = `(${numericValue.slice(0, 3)}`;
    }
    if (numericValue.length > 3) {
      formattedValue += `)${numericValue.slice(3, 6)}`;
    }
    if (numericValue.length > 6) {
      formattedValue += `-${numericValue.slice(6, 10)}`;
    }
    setValues({
      ...values,
      [fieldName]: formattedValue,
    });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("first");
    for (let key of Object.keys(driverData)) {
      if (driverData[key] === "") {
        delete driverData[key];
      }
    }
    dispatch(createUser(driverData, cb));
  };

  return (
    <>
      <div
        className={`modal fade ${showAddModal === true ? "show" : "hide"}`}
        id="addnewModal"
        tabIndex="-1"
        aria-labelledby="addnewModalLabel"
        // aria-hidden="true"
        onClick={(e) => {
          // Check if the click occurred outside the modal content
          if (e.target === e.currentTarget) {
            openAddModal(); // Call your close modal function
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addnewModalLabel">
                Manage Drivers
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => openAddModal()}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="col-md-12">
                  <div className="text-center mb-5">
                    <label className="avatar avatar-xxl profile-cover-avatar m-0 m-auto">
                      {/* Profile Image */}
                      {selectedImage && (
                        <img
                          className="rounded border shadow-sm"
                          src={selectedImage}
                          alt="Profile Image"
                        />
                      )}
                      {/* Hidden File Input */}
                      <input
                        type="file"
                        accept=".jpg, .jpeg, .png"
                        onChange={handleChangePic}
                      />
                      {/* Edit Icon */}
                      <span
                        className="avatar-edit"
                        type="file"
                        accept=".jpg, .jpeg, .png"
                        onChange={handleChangePic}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-edit-2 avatar-uploader-icon shadow-soft"
                        >
                          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                        </svg>
                      </span>
                    </label>
                    <p
                      className="fw-light text-info"
                      style={{ fontSize: "12px" }}
                    >
                      .jpg, .jpeg, .png recommended size (512 X 512) pixels
                    </p>
                  </div>
                </div>

                <fieldset>
                  <legend>DRIVER DETAILS</legend>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="fName">First Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="fName"
                          placeholder="First Name"
                          value={values.firstName}
                          onChange={handleChange("firstName")}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="lName">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="lName"
                          placeholder="Last Name"
                          value={values.lastName}
                          onChange={handleChange("lastName")}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          id="Email"
                          placeholder="Email"
                          value={values.email}
                          onChange={handleChange("email")}
                          // required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="password"
                          placeholder="Password"
                          value={values.password}
                          onChange={handleChange("password")}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor="countrycode">Country code</label>
                        <input
                          type="text"
                          className="form-control"
                          id="countrycode"
                          placeholder="Country code"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="mobile">Mobile</label>
                        <input
                          type="text"
                          className="form-control"
                          id="mobile"
                          placeholder="Mobile"
                          value={values.phone}
                          onChange={handlePhone("phone")}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="form-group">
                        <label htmlFor="gender">Gender</label>
                        <select
                          className="form-select"
                          id="gender"
                          value={values.gender}
                          onChange={handleChange("gender")}
                        >
                          <option value="0" selected disabled>
                            Select Gender
                          </option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="address">Driver Address</label>
                        <input
                          className="form-control"
                          id="address"
                          // rows="3"
                          placeholder="Driver Address"
                          value={values.address}
                          onChange={handleChange("address")}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="Latitude">Latitude</label>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          id="Latitude"
                          placeholder="Latitude"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="Longitude">Longitude</label>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          id="Longitude"
                          placeholder="Longitude"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="selectCity">Select City</label>
                        <select className="form-select" id="selectCity">
                          <option value="0" selected disabled>
                            {" "}
                            Please Select City
                          </option>
                          {city?.city?.map((x) => (
                            <option key={x?.id} value={x.id}>
                              {x?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={() => openAddModal()}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminCreateDriverModal;
